import { i18n } from '@/common/locale';
import type { SlideDetailAdapterResultKey } from '@/common/types/slideDetailAdapter.types';
import { isAxiosError } from 'axios';
import {
  FieldMissingError,
  InvalidDatabaseTypeError,
  InvalidDetailTypeError,
  InvalidTargetError,
  InvalidFieldValueError,
} from './adapters';

export const getErrorMessageFromError = (e: unknown): string | null => {
  console.log(e);

  if (isAxiosError(e) && e.response?.status === 404) {
    return i18n.global.t('MESSAGE.TARGET_ID_NOT_EXIST');
  }
  if (e instanceof InvalidTargetError) {
    return i18n.global.t('MESSAGE.LINK_MISSING_REQUIRED_PARAMS', { type: '', value: e.targetId });
  }
  if (e instanceof FieldMissingError) {
    return i18n.global.t('MESSAGE.LINK_MISSING_REQUIRED_PARAMS', {
      type: e.type ? `${e.type} ` : '',
      value: e.value,
    });
  }
  if (e instanceof InvalidFieldValueError) {
    return i18n.global.t('MESSAGE.LINK_INVALID_FIELD_VALUE', {
      type: e.type ? `${e.type} ` : '',
      field: e.field,
      message: e.message,
    });
  }
  if (e instanceof InvalidDatabaseTypeError) {
    return i18n.global.t('MESSAGE.LINK_INVALID_DB_TYPE', { value: e.dbType });
  }
  if (e instanceof InvalidDetailTypeError) {
    return i18n.global.t('MESSAGE.LINK_INVALID_DETAIL_TYPE', { value: e.detailType });
  }
  return null;
};

export const convertDatabaseDetailErrorToSlideDetailAdapterError = (
  e: unknown,
): SlideDetailAdapterResultKey => {
  if (isAxiosError(e) && e.response?.status === 404) {
    return 'deleted';
  }
  if (e instanceof InvalidTargetError) {
    return 'invalid_params';
  }
  if (e instanceof InvalidFieldValueError) {
    return 'invalid_params';
  }
  if (e instanceof FieldMissingError) {
    return 'invalid_params';
  }
  if (e instanceof InvalidDatabaseTypeError) {
    return 'invalid_db_type';
  }
  if (e instanceof InvalidDetailTypeError) {
    return 'invalid_detail_type';
  }
  return 'unknown_error';
};
